import React, { useState } from "react";
import { Tabs, TabList, Tab, useColorMode } from "@chakra-ui/react";

function ThemeToggleTabs({isOpen}) {
  const { colorMode, toggleColorMode } = useColorMode();
  const [selectedTab, setSelectedTab] = useState(colorMode);

  const handleTabChange = (index) => {
    const mode = index === 0 ? "light" : "dark";
    // if (mode !== colorMode) toggleColorMode();
    setSelectedTab(mode);
  };

  return (
    <>
    {/* <Heading color="text">Welcome to Chakra + TS</Heading> */}
    <Tabs
      display={isOpen ? "block" : "none"}
      index={selectedTab === "light" ? 0 : 1}
      onChange={handleTabChange}
      variant="soft-rounded"
      w={"95%"}
      m={"auto"}
      p={1}
      bg={"#232627"}
      borderRadius={"12px"}
      mt={"3px"}
      //   mb={"14px"}
      //   align="center"
    >
      <TabList>
        <Tab
          _selected={{
            bg: "rgba(20, 23, 24, 1)",
            color: "white",
          }}
          borderRadius={"10px"}
          w={"49%"}
          mr={"3px"}
          py={1}
          fontSize={"14px"}
        >
          Light
        </Tab>
        <Tab
          _selected={{
            bg: "rgba(20, 23, 24, 1)",
            color: "white",
          }}
          bg={"#232627"}
          borderRadius={"10px"}
          w={"49%"}
          py={1}
          fontSize={"14px"}
        >
          Dark
        </Tab>
      </TabList>
    </Tabs>
    </>
  );
}

export default ThemeToggleTabs;
